"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMoment = exports.catchTheMoment = exports.formatDate = exports.formatNumber = exports.formatCurrency = exports.formatMessage = exports.getLocale = exports.getIntl = exports.translate = exports.getStoredSpaceTranslations = exports.getFetchedTranslations = exports.setTranslations = exports.fetchSpaces = exports.setConfig = exports.NumberFormat = exports.timeZones = exports.Currency = exports.DateFormat = exports.filterTimeZone = exports.guessTimeZone = exports.getTimeZoneNameById = exports.convertGrLocaleToBcpOrFallbackToDefault = exports.convertGrLocaleToBcpLocale = exports.FormattedNumber = exports.DateTime = exports.FormattedCurrency = exports.IntlProvider = exports.voidElements = exports.availableConverters = exports.attachKey = exports.defaultElementConverters = exports.renderChunk = exports.TranslationProvider = exports.Translation = exports.TranslationsService = void 0;
var TranslationsService_1 = require("./TranslationsService");
var moment = require("moment-timezone");
var TranslationsService_2 = require("./TranslationsService");
Object.defineProperty(exports, "TranslationsService", {
  enumerable: true,
  get: function get() {
    return TranslationsService_2.TranslationsService;
  }
});
var Translation_1 = require("./react/Translation/Translation");
Object.defineProperty(exports, "Translation", {
  enumerable: true,
  get: function get() {
    return Translation_1.Translation;
  }
});
var TranslationProvider_1 = require("./react/TranslationProvider/TranslationProvider");
Object.defineProperty(exports, "TranslationProvider", {
  enumerable: true,
  get: function get() {
    return TranslationProvider_1.TranslationProvider;
  }
});
var renderChunk_1 = require("./react/Translation/renderChunk");
Object.defineProperty(exports, "renderChunk", {
  enumerable: true,
  get: function get() {
    return renderChunk_1.renderChunk;
  }
});
var defaultElementConverters_1 = require("./react/Translation/defaultElementConverters");
Object.defineProperty(exports, "defaultElementConverters", {
  enumerable: true,
  get: function get() {
    return defaultElementConverters_1.defaultElementConverters;
  }
});
Object.defineProperty(exports, "attachKey", {
  enumerable: true,
  get: function get() {
    return defaultElementConverters_1.attachKey;
  }
});
Object.defineProperty(exports, "availableConverters", {
  enumerable: true,
  get: function get() {
    return defaultElementConverters_1.availableConverters;
  }
});
Object.defineProperty(exports, "voidElements", {
  enumerable: true,
  get: function get() {
    return defaultElementConverters_1.voidElements;
  }
});
var IntlProvider_1 = require("./react/IntlProvider/IntlProvider");
Object.defineProperty(exports, "IntlProvider", {
  enumerable: true,
  get: function get() {
    return IntlProvider_1.IntlProvider;
  }
});
var Currency_1 = require("./react/Currency/Currency");
Object.defineProperty(exports, "FormattedCurrency", {
  enumerable: true,
  get: function get() {
    return Currency_1.FormattedCurrency;
  }
});
var DateTime_1 = require("./react/DateTime/DateTime");
Object.defineProperty(exports, "DateTime", {
  enumerable: true,
  get: function get() {
    return DateTime_1.DateTime;
  }
});
var FormattedNumber_1 = require("./react/FormattedNumber/FormattedNumber");
Object.defineProperty(exports, "FormattedNumber", {
  enumerable: true,
  get: function get() {
    return FormattedNumber_1.FormattedNumber;
  }
});
var locale_1 = require("./utils/locale");
Object.defineProperty(exports, "convertGrLocaleToBcpLocale", {
  enumerable: true,
  get: function get() {
    return locale_1.convertGrLocaleToBcpLocale;
  }
});
Object.defineProperty(exports, "convertGrLocaleToBcpOrFallbackToDefault", {
  enumerable: true,
  get: function get() {
    return locale_1.convertGrLocaleToBcpOrFallbackToDefault;
  }
});
var timeZone_1 = require("./utils/timeZone");
Object.defineProperty(exports, "getTimeZoneNameById", {
  enumerable: true,
  get: function get() {
    return timeZone_1.getTimeZoneNameById;
  }
});
Object.defineProperty(exports, "guessTimeZone", {
  enumerable: true,
  get: function get() {
    return timeZone_1.guessTimeZone;
  }
});
Object.defineProperty(exports, "filterTimeZone", {
  enumerable: true,
  get: function get() {
    return timeZone_1.filterTimeZone;
  }
});
var dateFormat_1 = require("./constants/dateFormat");
Object.defineProperty(exports, "DateFormat", {
  enumerable: true,
  get: function get() {
    return dateFormat_1.DateFormat;
  }
});
var currency_1 = require("./constants/currency");
Object.defineProperty(exports, "Currency", {
  enumerable: true,
  get: function get() {
    return currency_1.Currency;
  }
});
var timeZone_2 = require("./constants/timeZone");
Object.defineProperty(exports, "timeZones", {
  enumerable: true,
  get: function get() {
    return timeZone_2.timeZones;
  }
});
var numberFormat_1 = require("./constants/numberFormat");
Object.defineProperty(exports, "NumberFormat", {
  enumerable: true,
  get: function get() {
    return numberFormat_1.NumberFormat;
  }
});
function setConfig(config) {
  TranslationsService_1.defaultTranslationsService.setConfig(config);
}
exports.setConfig = setConfig;
function fetchSpaces(spaces) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, TranslationsService_1.defaultTranslationsService.fetch(spaces)];
    });
  });
}
exports.fetchSpaces = fetchSpaces;
function setTranslations(keys) {
  return TranslationsService_1.defaultTranslationsService.setTranslations(keys);
}
exports.setTranslations = setTranslations;
function getFetchedTranslations() {
  return TranslationsService_1.defaultTranslationsService.getTranslations();
}
exports.getFetchedTranslations = getFetchedTranslations;
function getStoredSpaceTranslations(spaces) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, TranslationsService_1.defaultTranslationsService.getStoredSpaceTranslations(spaces)];
    });
  });
}
exports.getStoredSpaceTranslations = getStoredSpaceTranslations;
function translate(id, values) {
  if (values === void 0) {
    values = {};
  }
  return TranslationsService_1.defaultTranslationsService.getIntl().translate(id, values);
}
exports.translate = translate;
function getIntl() {
  return TranslationsService_1.defaultTranslationsService.getIntl().getIntlObject();
}
exports.getIntl = getIntl;
function getLocale() {
  return TranslationsService_1.defaultTranslationsService.getLocale();
}
exports.getLocale = getLocale;
function formatMessage(_a, values) {
  var id = _a.id;
  if (values === void 0) {
    values = {};
  }
  return translate(id, values);
}
exports.formatMessage = formatMessage;
function formatCurrency(value, currency, minimumFractionDigits) {
  if (minimumFractionDigits === void 0) {
    minimumFractionDigits = 2;
  }
  return TranslationsService_1.defaultTranslationsService.getIntl().formatCurrency(value, currency, minimumFractionDigits);
}
exports.formatCurrency = formatCurrency;
function formatNumber(value, options) {
  if (options === void 0) {
    options = {};
  }
  return TranslationsService_1.defaultTranslationsService.getIntl().formatNumber(value, options);
}
exports.formatNumber = formatNumber;
function formatDate(value, options) {
  return TranslationsService_1.defaultTranslationsService.getIntl().formatDate(value, options);
}
exports.formatDate = formatDate;
function catchTheMoment(value, options) {
  if (options === void 0) {
    options = {};
  }
  return TranslationsService_1.defaultTranslationsService.getIntl().catchTheMoment(value, options);
}
exports.catchTheMoment = catchTheMoment;
function getMoment() {
  return moment;
}
exports.getMoment = getMoment;